import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=5e0e5977&scoped=true&"
import script from "./SearchItem.vue?vue&type=script&lang=ts&"
export * from "./SearchItem.vue?vue&type=script&lang=ts&"
import style0 from "./SearchItem.vue?vue&type=style&index=0&id=5e0e5977&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0e5977",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
